// store.js
import { createStore } from 'vuex';

const savedUser = localStorage.getItem('user');

const store = createStore({
  state: {
    user: savedUser ? JSON.parse(savedUser) : null,
    isAuthenticated: !!localStorage.getItem('jwt')
  },

  mutations: {
    setUser(state, user) {
      state.user = user;
      state.isAuthenticated = !!user;
    },

    logout(state) {
      state.user = null;
      state.isAuthenticated = false;
    }
  },

  actions: {
    setUser({ commit }, user) {
      commit('setUser', user);
    },

    logout({ commit }) {
      commit('logout');

      localStorage.removeItem('jwt');
      localStorage.removeItem('jwt_issued_at');
      localStorage.removeItem('user');
    }
  },

  getters: {
    isAuthenticated: (state) => state.isAuthenticated,
    user: (state) => state.user
  }
});

export default store;
